<ngb-carousel *ngIf="sliderImages" (slide)="onSlide($event)">
  <ng-template ngbSlide *ngFor="let image of sliderImages">
    <img [src]="image" alt="" class="w-100" />
  </ng-template>
</ngb-carousel>
